import React from 'react';
import { useProjectStatusHistory } from '@/hooks/useProjectStatusHistory';
import EntityTimeline, { TimelineEntry } from '@/components/shared/EntityTimeline';

interface ProjectStatusHistoryProps {
  projectId: string;
}

/**
 * ProjectStatusHistory - Displays the status change history for a project
 * 
 * Uses the reusable EntityTimeline component with project-specific data.
 * Shows when status changes occurred, who made them, and any notes.
 */
const ProjectStatusHistory: React.FC<ProjectStatusHistoryProps> = ({ projectId }) => {
  const { data: history = [], isLoading } = useProjectStatusHistory(projectId);

  // Transform the project-specific history to generic timeline entries
  const entries: TimelineEntry[] = history.map((entry) => ({
    id: entry.id,
    previousStatus: entry.previous_status,
    newStatus: entry.new_status,
    changedBy: entry.changedByName || 'Unknown User',
    changedAt: entry.changed_at,
    notes: entry.notes,
  }));

  return (
    <EntityTimeline
      title="Status History"
      entityType="project"
      entries={entries}
      isLoading={isLoading}
      emptyMessage="No status changes recorded yet."
    />
  );
};

export default ProjectStatusHistory;
